"use strict";
import Button from "./Button";

function Common() {
}
export default Common;

Common.smoothie = null;

/**
 * @type {Array}
 */
Common.displayObjs = null;

/**
 * Total fly distance achieved in a game
 * @type {number}
 */
Common.flyDist = 0;

/**
 * @type {Charm}
 */
Common.charm = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @type {string}
 */
Common.homeURL = "http://www.boomerangtv.co.uk/games";

/**
 * Semi unique key used as an identifier, followed by the version
 * @type {string}
 */
Common.game_key = "game_data_0lkwjtndqata_gold_v1_2";

/**
 * @type {number[]}
 */
Common.highScores = [0, 0, 0];

/**
 * @type {p3.View}
 */
Common.view = null;

/**
 * Basic physics module provides some simple functions to bounce sprites off each other etc.
 * @type {Physics}
 */
//Common.physics = null;

/**
 * @type {number}
 * @static
 * @const
 */
Common.STAGE_WIDTH = 1900;

/**
 * @type {number}
 * @static
 * @const
 */
Common.STAGE_HEIGHT = 1024;

/**
 * @type {PIXI.Container}
 * @static
 */
Common.stage = null;

/**
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 * @static
 */
Common.renderer = null;

/**
 * @type {p3.Timestep}
 * @static
 */
Common.timestep = null;

/**
 * @type {p3.Tracking}
 * @static
 */
Common.tracking = null;

/**
 * @type {AudioManager}
 * @static
 */
Common.audio = null;

/**
 * @type {p3.Camera}
 * @static
 */
Common.camera = null;

/**
 * @type {Player}
 * @static
 */
//Common.player = null;

/**
 * @type {object}
 * @static
 */
Common.copy = null;

/**
 * @type {object}
 * @static
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @type {PIXI.Point}
 * @static
 */
Common.touch = new PIXI.Point(0.0, 0.0);

/**
 * @type {boolean}
 * @static
 */
Common.touching = false;

/**
 * @type {number}
 * @static
 */
Common.paused = false;

/**
 * @type {boolean}
 * @static
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 * @static
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 * @static
 */
Common.debug = null;

/**
 * @type {boolean}
 * @static
 */
Common.devDebug = false;

/**
 * @type {boolean}
 * @static
 */
Common.isMute = false;

/**
 * Creates and returns a new button
 * @param x - Coordinate
 * @param y - Coordinates
 * @param type - Button type
 * @param clickFunc - Target function
 * @param scope  -This context
 * @param holder - Display container optional arg]
 * @param icon - btn icon
 * @returns {Button}
 */
Common.createButton = function (x, y, type, clickFunc, scope, holder, icon) {

    var states = new p3.ButtonStates();

    if (type === null || type === undefined) {
        states.normal = Common.assets.getTexture("pause_btn_frame");
        states.over = Common.assets.getTexture("pause_btn_frame");
    } else if (typeof type === "string") {
        states.normal = Common.assets.getTexture("btn_" + type + "_off");
        states.over = Common.assets.getTexture("btn_" + type + "_over");
        states.down = Common.assets.getTexture("btn_" + type + "_down");
    } else {
        states.normal = type;

    }

    //lil hax so forward and back sounds are assigned correctly
    var button;
    if (type == "back" || type == "close" || type == "exit" || type == "home" || type == "menu" || typeof type !== "string") {
        button = new Button(states, this);
        if (typeof type !== "string") button.compositeSprite = type;
    } else {
        button = new Button(states, this, "fwd");
    }

    button.x = x;
    button.y = y;
    button.anchor = new PIXI.Point(0.5, 0.5);
    button.animate = true;

    button.signals.click.add(clickFunc, scope);

    if (holder) holder.addChild(button);

    /*
     if (debugText) {
     let text = new PIXI.Text(debugText, {fontFamily: "Arial", fontSize: "32px"});
     text.anchor = {x: 0.5, y: 0.5};
     button.addChild(text);
     }
     */

    if (icon) {
        button.icon = new PIXI.Sprite(Common.assets.getTexture(icon));
        button.icon.anchor.set(0.5);
        button.addChild(button.icon);
    }

    return button;
};

/**
 * Knuth shuffle variation
 * @param string
 * @returns {string}
 */
Common.shuffleString = (string)=> {
    const a = string.split(""); //our array
    const n = a.length; //number of elements

    for (let i = n - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    var theta = Math.atan2(dy, dx); // range (-PI, PI]
    ///theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
    return theta;
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

/**
 * @param {number} deg
 * @returns {number} rad
 */
Common.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

Common.rad2deg = function (rad) {
    return rad *= 180 / Math.PI; // rads to degs, range (-180, 180]
};

/**
 * Uses quick sort to sort an array, with optional flag to sort high to low
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sort = function (array, highToLow) {
    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i] < pivot) swap(index++, i);
                else if (highToLow && array[i] > pivot)swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts tiles (or any display object) by x, y coordinates so they are ordered lowest top to bottom , left to right
 * @param array
 * @returns {*}
 */
Common.sortTiles = function (array) {
    array.sort(function (a, b) {
        if (a.y == b.y) return a.x - b.x;
        return a.y - b.y;
    });
    return array;
};

/**
 * Uses oriented bounding box (OBB) to check collisions with optional tuning arg to make bounds bigger or smaller
 * @param r1
 * @param r2
 * @param tuner
 * @returns {boolean}
 */
Common.collisionOBB = function (r1, r2, tuner) {
    if (!tuner || tuner <= 0) tuner = 1;
    r1 = r1.getBounds();
    r2 = r2.getBounds();

    return !(r2.x > (r1.x + r1.width * tuner) ||
    (r2.x + r2.width * tuner) < r1.x ||
    r2.y > (r1.y + r1.height * tuner) ||
    (r2.y + r2.height * tuner) < r1.y);
};

/**
 * Returns a new keyboard object that listens for keyboard input
 * @param keyCode
 * @returns {{}}
 */
Common.keyboard = function (keyCode) {
    var key = {};
    key.code = keyCode;
    key.isDown = false;
    key.isUp = true;
    key.down = undefined;
    key.up = undefined;
    //The `downHandler`
    key.downHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isUp && key.down) key.down();
            key.isDown = true;
            key.isUp = false;
        }
        event.preventDefault();
    };

    //The `upHandler`
    key.upHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isDown && key.up) key.up();
            key.isDown = false;
            key.isUp = true;
        }
        event.preventDefault();
    };

    //Attach event listeners
    window.addEventListener(
        "keydown", key.downHandler.bind(key), false
    );
    window.addEventListener(
        "keyup", key.upHandler.bind(key), false
    );
    return key;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @returns {PIXI.Sprite|String}
 */
Common.generateRect = function (width, height, colour) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0x000fff);
    g.drawRect(0, 0, width, height);
    g.endFill();
    let sprite = new PIXI.Sprite(Common.renderer.generateTexture(g));
    sprite.anchor = {x: 0.5, y: 0.5};
    g.destroy();
    return sprite;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - Should we return a texture or a sprite
 * @returns {PIXI.Sprite|PIXI.Texture}
 */
Common.generateEllipse = function (width, height, colour, retTexture) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0xfff000);
    g.drawEllipse(0, 0, width, height);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    let sprite = new PIXI.Sprite(texture);
    sprite.anchor = {x: 0.5, y: 0.5};
    g.destroy();
    if (!retTexture) return sprite;
    else return texture;
};

/**
 * Centres all sprites passed to it
 * @param sprite
 */
Common.centreAnchor = function (sprite) {
    for (let i = 0; i < arguments.length; i++) {
        arguments[i].anchor = {x: 0.5, y: 0.5};
    }
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = (a) => {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
    return a;
};

/**
 * Returns a matrix of defined size with optional initial values
 * @param {number} numRows - Number rows in matrix
 * @param {number} numCols - Number of columns in matrix
 * @param initial - Optional initial value
 * @returns {Array}
 */
Common.matrix = function (numRows, numCols, initial) {
    var arr = [];
    for (var i = 0; i < numRows; i++) {
        var columns = [];
        for (var j = 0; j < numCols; j++) columns[j] = initial;
        arr[i] = columns;
    }
    return arr;
};

/**
 * Returns array of defined size with optional initial values
 * @param {number} size
 * @param initial
 * @returns {Array}
 */
Common.array = function (size, initial) {
    var arr = [];
    for (var i = 0; i < size; i++) arr.push(initial);
    return arr;
};

Common.saveGame = function () {
    let gameData = {
        highScores: Common.highScores,
        isFirstPlay: Common.isFirstPlay
    };
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    //if the data exists get it
    let gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.highScores = gameData.highScores;
        Common.isFirstPlay = gameData.isFirstPlay;
    }// else Common.isFirstPlay = true;
};

/**
 * @param a
 * @param b
 * @returns {{x: *, y: *}}
 */
Common.vectorAdd = function (a, b) {
    return {x: a.x + b.x, y: a.y + b.y};
};

/**
 * @param a
 * @param b
 * @returns {{x: number, y: number}}
 */
Common.vectorSub = function (a, b) {
    return {x: a.x - b.x, y: a.y - b.y};
};

/**
 * @param a
 * @param b
 * @returns {{x: number, y: number}}
 */
Common.vectorMulti = function (a, b) {
    return {x: a.x * b.x, y: a.y * b.y};
};

/**
 * @param start
 * @param end
 * @param perc - range 0...1
 * @returns {{x, y}|{x: *, y: *}}
 */
Common.lerp = function (start, end, perc) {
    // return (start + perc * (end - start));
    const endMinusStart = Common.vectorSub(end, start);
    //  console.log(endMinusStart);
    // const multiPerc = Common.vectorMulti(perc, endMinusStart);
    endMinusStart.x *= perc;
    endMinusStart.y *= perc;
    // console.log(multiPerc);
    return Common.vectorAdd(start, endMinusStart);
};

/**
 * @param x
 * @param y
 */
Common.toPercent = function (x, y) {
    return (100) * (y / x);
};

Common.lerp = function (obj, time, target, cb) {
    time *= 1000; //to ms
    const lerp = {startTime: Date.now(), obj: obj, time: time, cb: cb, target: target};
    lerp.update = ()=> {
        const elapsed = Date.now() - lerp.startTime;
        if (elapsed >= lerp.time) {
            if (lerp.cb) lerp.cb();
            return true;
        }
        const perc = (Common.toPercent(lerp.time, elapsed) / 100);
        const updated = Common.lerp(lerp.obj, lerp.target, perc / 25);
        lerp.obj.x = updated.x;
        lerp.obj.y = updated.y;
    };
    //--lerp's should be pushed onto an array for updating--//
    //--put below in update function to update lerp's--//
    /*
     for (let i in this._lerps) {
     if (this._lerps[i].update()) {
     this._lerps[i] = null;
     delete this._lerps[i];
     this._lerps.splice(i, 1);
     }
     }
     */
    return lerp;
};

Common.getFrag = function (quality, distance) {
    return [
        'precision mediump float;',
        'varying vec2 vTextureCoord;',
        'uniform sampler2D texture;',
        'uniform float distance;',
        'uniform float outerStrength;',
        'uniform float innerStrength;',
        'uniform vec4 glowColor;',
        'uniform float pixelWidth;',
        'uniform float pixelHeight;',
        'vec2 px = vec2(pixelWidth, pixelHeight);',
        'void main(void) {',
        '    const float PI = 3.14159265358979323846264;',
        '    vec4 ownColor = texture2D(texture, vTextureCoord);',
        '    vec4 curColor;',
        '    float totalAlpha = 0.;',
        '    float maxTotalAlpha = 0.;',
        '    float cosAngle;',
        '    float sinAngle;',
        '    for (float angle = 0.; angle <= PI * 2.; angle += ' + (1 / quality / distance).toFixed(7) + ') {',
        '       cosAngle = cos(angle);',
        '       sinAngle = sin(angle);',
        '       for (float curDistance = 1.; curDistance <= ' + distance.toFixed(7) + '; curDistance++) {',
        '           curColor = texture2D(texture, vec2(vTextureCoord.x + cosAngle * curDistance * px.x, vTextureCoord.y + sinAngle * curDistance * px.y));',
        '           totalAlpha += (distance - curDistance) * curColor.a;',
        '           maxTotalAlpha += (distance - curDistance);',
        '       }',
        '    }',
        '    maxTotalAlpha = max(maxTotalAlpha, 0.0001);',

        '    ownColor.a = max(ownColor.a, 0.0001);',
        '    ownColor.rgb = ownColor.rgb / ownColor.a;',
        '    float outerGlowAlpha = (totalAlpha / maxTotalAlpha)  * outerStrength * (1. - ownColor.a);',
        '    float innerGlowAlpha = ((maxTotalAlpha - totalAlpha) / maxTotalAlpha) * innerStrength * ownColor.a;',
        '    float resultAlpha = (ownColor.a + outerGlowAlpha);',
        '    gl_FragColor = vec4(mix(mix(ownColor.rgb, glowColor.rgb, innerGlowAlpha / ownColor.a), glowColor.rgb, outerGlowAlpha / resultAlpha) * resultAlpha, resultAlpha);',
        '}'
    ];
};